export default "__VITE_ASSET__DLAkaZaY__"